import { SpatialTreeNode } from "./tree.spatial.node";
import { QuadtreeSplitter } from "./tree.spatial.splitters";
export class SpatialTree {
    constructor(maxDepth = SpatialTree.DefaultMaxDepth, maxItemPerNode = SpatialTree.DefaultMaxItemPerNode, subdivision = new QuadtreeSplitter(), lookupThreshold = SpatialTree.DefaultLookupThreshold) {
        this._splitter = subdivision;
        this._maxDepth = maxDepth;
        this._maxItemPerNode = maxItemPerNode;
        this._lookupThresold = lookupThreshold;
        this._root = new SpatialTreeNode();
        this._context = this._buildContext();
    }
    get root() {
        return this._root;
    }
    get spliter() {
        return this._splitter;
    }
    get maxDepth() {
        return this._maxDepth;
    }
    get maxItemPerNode() {
        return this._maxItemPerNode;
    }
    get lookupThreshold() {
        return this._lookupThresold;
    }
    get factory() {
        return this._buildNode;
    }
    add(...data) {
        this._root.add(this._context, Array.from(data));
    }
    remove(...data) {
        this._root.remove(this._context, Array.from(data));
    }
    lookupToRef(bounds, ref) {
        this._root.lookupToRef(this._context, bounds, ref);
    }
    _buildNode(bounds, depth) {
        return new SpatialTreeNode(bounds, depth);
    }
    _buildContext() {
        return { tree: this, lookupThreshold: this._lookupThresold };
    }
}
SpatialTree.DefaultMaxDepth = 32;
SpatialTree.DefaultMaxItemPerNode = 32;
SpatialTree.DefaultLookupThreshold = 512;
//# sourceMappingURL=tree.spatial.js.map